
(function($, App, Utils){
  'use strict';

  const Log = new Logger("Utilities");

  var IS_SPECIAL_REGEXP = /^\((sel|var|ary):(.*)\)$/;

  function isSpecial(value) {
    var matches = value.match( IS_SPECIAL_REGEXP );
    return matches && matches.length > 1;
  }
  function isSelector( value ){
    var matches = value.match( IS_SPECIAL_REGEXP );
    if ( matches[1] == "sel" )
      return matches[2];
  }
  function isVariable( value ){
    var matches = value.match( IS_SPECIAL_REGEXP );
    if ( matches[1] == "var" )
      return matches[2];
  }
  function isArray( value ){
    var matches = value.match( IS_SPECIAL_REGEXP );
    if ( matches[1] == "ary" )
      return matches[2];
  }

  Utils.URI = URI;

  Utils.CurURL = function() {
    return Utils.URI();
  };

  Utils.isTouch = function() {
    return App.Html.hasClass("touchevents");
  };

  Utils.nsData = function(el, key) {
    var $el = $(el), itemdata = $el.data( key );
    if ( !itemdata ) {
      itemdata = Utils.jsonDA(el, key);
      $el.data(key, itemdata);
    }
    return itemdata;
  };

  Utils.setInputFilter = function(textbox, inputFilter) {
    textbox.on("input", function() {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  },

  Utils.jsonDA = function(el, key){
    var json = {};
    el = $(el)[0];
    if ( !el || !el.attributes ) {
      Log.error("'el' paramater is not a valid HTML element");
      return json;
    }

    for ( var i_attr = 0, l_attr = el.attributes.length; i_attr < l_attr; i_attr++ ) {
      var
        attr = el.attributes[ i_attr ],
        name = attr.name,
        value = attr.value;
      if ( name.indexOf( "data-" ) == 0 ) {
        // found a data- attribute
        var
          names = name.split("-").slice(1),
          obj = json,
          name,
          original_data_attribute = [];

        while( name = names.shift() ) {

          // trasformation in camelCase
          var nn = name.split( /(?=_)_/ );
          for( var z = 1, zl = nn.length; z < zl; z++ ) {
            if ( ! nn[ z ] ) {
              nn[ z++ ] = "_";

            } else {
              nn[ z ] = nn[z].substring(0, 1).toUpperCase() + nn[z].substring(1);
            }
          }
          name = nn.join("");

          original_data_attribute.push( name );

          if ( ! names.length ) {
            // last element, we have to calculate its value
            obj[ name ] = (function(){
              // check special attribute
              var selvar;
              if ( isSpecial(value) ) {
                if ( selvar = isSelector(value) ) {
                  value = $( selvar ).val();
                } else if ( selvar = isVariable(value) ) {
                  value = window[ selvar ];
                } else if ( selvar = isArray(value) ) {
                  // collect array from DOM following the `original_data_attribute` as rootscope
                  var children = $(el).find( selvar );
                  value = [];
                  for( var i_c = 0, c; c = children[i_c++]; ){
                    var json_da_child = Utils.jsonDA( c, original_data_attribute.join(".") );
                    value.push( json_da_child );
                  }
                }
              }

              if ( value == "true" ) value = true;
              if ( value == "false" ) value = false;

              return typeof obj[ name ] !== "object" ? value : obj[ name ];
            })();
          } else {
            // create a temporary object to store data
            obj[ name ] = typeof obj[ name ] !== "object" ? {} : obj[ name ];
            obj = obj[ name ];
          }
        }
      }
    }

    return key ? (function(){
      var keys = key.split("."), k, o = json;
      while((k = keys.shift()) && o)
        o = o[ k ]
      return o;
    })(): json;
  };

  Utils.trackGTM = function(data) {

    if (! window.dataLayer) return;
    // Log.i("GTM Track page", data);
    dataLayer.push( Object.assign({}, data ) );
  }


  Utils.sanitizeUrl = (url) => {
    if (typeof url === 'undefined') return false;
    if (url.includes('?')) url = url.split('?')[0].slice(0, -1);

    return url;
  }

  Utils.isAbsoluteUrl = url => { 
    if (typeof url === 'undefined') return false;
    return /^[a-z][a-z0-9+.-]*:/.test(url); 
  }

  const accentsMap = {
    a: 'á|à|ã|â|À|Á|Ã|Â',
    e: 'é|è|ê|É|È|Ê|&',
    i: 'í|ì|î|Í|Ì|Î',
    o: 'ó|ò|ô|õ|Ó|Ò|Ô|Õ',
    u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
    c: 'ç|Ç',
    n: 'ñ|Ñ'
  };

  Utils.slugify = text => Object.keys(accentsMap).reduce((acc, cur) => acc.replace(new RegExp(accentsMap[cur], 'g'), cur), text.replace(/\.$/, '')).toLowerCase().replace(/[^\w-]+/g, '-');

  Utils.lastPathName = (url) => {
    if (typeof url === 'undefined') return false;
    if (url.includes('?')) url = url.split('?')[0].slice(0, -1);

    return url.substring(url.lastIndexOf('/') + 1);
  }

  Utils.toCamelCase = (str) => {
    return str.toLowerCase().trim().replace(/[-_\s]+(.)?/g, (_, c) => c ? c.toUpperCase() : '');
  }

  Utils.currencyFormatter = (num) => {
    return (
        num.toFixed(2) // always two decimal digits
           .replace('.', ',') // replace decimal point character with ,
           .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    ) // use . as a separator
  }

  Utils.sanitizeHTML = (str) => {
    return str.replace(/javascript:/gi, '').replace(/[^\w-_. ]/gi, function (c) {
      return `&#${c.charCodeAt(0)};`;
    });
  }


	Utils.disableSubmitButton = () => {
		$('form').submit(function() {
        $(this).find(':button[type=submit]').prop('disabled', true);
	  });
	}

})(jQuery, window.App, window.App.Utils );